import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import AppHeader from "./Header";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useFetchHealthQuery } from "store/RTK/healthApi";
import { useFetchSettingsQuery as useFetchShopSettingsQuery } from "store/RTK/optionsApi";

// Hoist the translated component so it isn't recreated on every render
const TranslatedAppHeader = withTranslation()(AppHeader);

const AppHeaderWrapper: React.FC<{ $duration: number }> = ({ $duration }) => {
  const isOnline = useSelector((state: RootState) => state.auth.isOnline);
  const { data: health, isError: isHealthError, isLoading } = useFetchHealthQuery();
  const backendHealthy = isLoading || (!isHealthError && health?.status === "ok");
  const { data: shopSettings } = useFetchShopSettingsQuery();
  const isUnderConstruction = Boolean((shopSettings as any)?.underConstruction);
  const location = useLocation();
  const isPreviewUC = location.pathname === "/__uc";
  return <TranslatedAppHeader isOnline={isOnline && backendHealthy && !isUnderConstruction && !isPreviewUC} $duration={$duration} />;
};

export default AppHeaderWrapper;
